// Phiên bản app (hiển thị cho nhân viên biết đang dùng bản nào).
// KHI BUMP: đổi ở ĐÂY + android/app/build.gradle (versionName/versionCode) cho khớp.
export const APP_VERSION = '4.8';
